<template>
  <div class="page">
    <el-form
      :inline="true"
      :model="formInline"
      label-position="left"
      class="demo-form-inline"
    >
      <el-form-item label="资讯标题">
        <el-input v-model="formInline.title" placeholder="资讯标题"></el-input>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker
          v-model="formInline.publishTime"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          value-format="yyyy-MM"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getTableData">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            dialogFormVisible = true;
            infoId = '';
          "
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      height="505"
      border
      style="width: 98%; overflow: auto"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="title" label="文章标题" width="500">
        <template slot-scope="scope">
          <span
            @click="jumpDetails(scope.row.id)"
            v-html="scope.row.title"
            class="title"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="publishTime" label="发表日期" width="200">
      </el-table-column>
      <el-table-column prop="year" label="年份" width="200"> </el-table-column>
      <el-table-column prop="issueNumber" label="期号" width="200">
      </el-table-column>
      <el-table-column prop="releaseTime" label="在平台发布时间" width="200">
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleUpdate(scope.row.id)"
            type="text"
            size="small"
            >修改
          </el-button>
          <el-button
            @click="handleDelete(scope.row.id)"
            type="text"
            size="small"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination" ref="page">
      <pagination
        style="padding: 0px"
        :total="total"
        :page.sync="formInline.pageNumber"
        :page-sizes="[8, 10, 20, 50]"
        :limit.sync="formInline.pageSize"
        @pagination="getTableData"
      />
    </div>

    <el-dialog
      title="新增"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :show-close="true"
    >
      <add-panel v-if="dialogFormVisible" :id="infoId"></add-panel>
    </el-dialog>
  </div>
</template>

<script>
import { deleteMedicalFrontiers, getMedicalFrontiers } from "@/api/api";
import addPanel from "@/components/addPanel.vue";
export default {
  components: { addPanel },
  data() {
    return {
      tableData: [],
      formInline: {
        content: "",
        dataScope: [],
        filedId: 0,
        id: 0,
        issueNumber: "",
        pageNumber: 1,
        pageSize: 10,
        publishTime: "",
        searchBeginTime: "",
        searchEndTime: "",
        searchStatus: 0,
        searchValue: "",
        status: 0,
        title: "",
        typeName: "",
        year: "",
      },
      total: 0,
      dialogFormVisible: false,
      infoId: "",
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    jumpDetails(id) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id, type: "10" },
      });
      window.open(routerUrl.href);
    },
    // 获取表格数据
    getTableData() {
      getMedicalFrontiers({
        ...this.formInline,
        publishTime: this.formInline.publishTime
          ? this.formInline.publishTime[0] +
            "_" +
            this.formInline.publishTime[1]
          : "",
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.totalRows;
        }
      });
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确定删除此信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMedicalFrontiers({ ids: [id] }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getTableData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleUpdate(id) {
      this.infoId = id;
      this.dialogFormVisible = true;
    },
    handleSearch() {
      this.formInline.pageNumber = 1;
      this.getTableData();
    },
    handleSelectionChange() {},
    handleAdd() {},
    handleClose() {
      this.getTableData();
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  width: 100%;
  height: 100%;
  .pagination {
    width: 100%;
    margin-top: 10px;
    text-align: right;
    padding-right: 20px;
  }
}

.title {
  cursor: pointer;
  &:hover {
    color: #13509f;
  }
}
</style>
